import { render, staticRenderFns } from "./Div_academica.vue?vue&type=template&id=2046dab3"
import script from "./Div_academica.vue?vue&type=script&lang=js"
export * from "./Div_academica.vue?vue&type=script&lang=js"
import style0 from "./Div_academica.vue?vue&type=style&index=0&id=2046dab3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports